import { httpClient } from '@/lib/http-client'
import type {
  RechargeLogData,
  CreateOrderParams,
  CreateOrderData,
  ProductListData,
  OrderStatusData,
  ConsumeLogData,
  WalletMyData,
  CheckInLogData,
  PagedQueryParams,
  CreateAirwallexOrderData,
} from './payment-types'

/** 充值记录 */
export const apiGetRechargeLog = (params: PagedQueryParams) => {
  return httpClient.get<ApiResponse<RechargeLogData>>('/wallet/recharge_log', params)
}

/** 创建订单 */
export const apiCreateOrder = (data: CreateOrderParams) => {
  return httpClient.post<ApiResponse<CreateOrderData>>('/wallet/order/create', data)
}

/** 商品列表 */
export const apiGetProductList = () => {
  return httpClient.get<ApiResponse<ProductListData>>('/wallet/product_list')
}

/** 查询订单状态（order_id 文档写为 Headers，此处用 query；若后端要求 header 可改为 config.headers） */
export const apiGetOrderStatus = (params: { order_id: string }) => {
  return httpClient.get<ApiResponse<OrderStatusData>>('/wallet/order/status', params)
}

/** 消费记录 */
export const apiGetConsumeLog = (params: PagedQueryParams) => {
  return httpClient.get<ApiResponse<ConsumeLogData>>('/wallet/consume_log', params)
}

/** 用户钱包 */
export const apiGetWalletMy = () => {
  return httpClient.get<ApiResponse<WalletMyData>>('/wallet/my')
}

/** 用户签到 */
export const apiCheckIn = () => {
  return httpClient.post<ApiResponse<Record<string, never>>>('/wallet/check_in')
}

/** 签到记录 */
export const apiGetCheckInLog = (params: PagedQueryParams) => {
  return httpClient.get<ApiResponse<CheckInLogData>>('/wallet/check_in_log', params)
}

// 创建airwallex订单
export const apiCreateAirwallexOrder = (data: { sku_id: string; return_url: string }) => {
  return httpClient.post<ApiResponse<CreateAirwallexOrderData>>('wallet/airwallex/purchase', data)
}
